
import { IconLookup, IconName, IconPrefix } from '@fortawesome/pro-solid-svg-icons';
import { ReactElement } from 'react';
import ConversationLeader from './icons/ConversationLeader';
import MasterNetwork from './icons/MasterNetwork';
import ProfileMaster from './icons/ProfileMaster';
import SuperNetwork from './icons/SuperNetwork';

export const HL_ICON_PREFIX = 'hli';

export type HLIconDefinition = IconLookup & {
  svg: ReactElement
}

export const conversationLeader: HLIconDefinition = {
  prefix: HL_ICON_PREFIX as IconPrefix,
  iconName: 'conversationLeader' as IconName,
  svg: ConversationLeader,
};
export const masterNetwork: HLIconDefinition = {
  prefix: HL_ICON_PREFIX as IconPrefix,
  iconName: 'masterNetwork' as IconName,
  svg: MasterNetwork,
};
export const profileMaster: HLIconDefinition = {
  prefix: HL_ICON_PREFIX as IconPrefix,
  iconName: 'profileMaster' as IconName,
  svg: ProfileMaster,
};
export const superNetwork: HLIconDefinition = {
  prefix: HL_ICON_PREFIX as IconPrefix,
  iconName: 'superNetwork' as IconName,
  svg: SuperNetwork
};

export const hlIcons = {
  conversationLeader, 
  masterNetwork, 
  profileMaster, 
  superNetwork
} 